import { render } from "./loader.vue?vue&type=template&id=21987d6b"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=21987d6b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__